const $inject = ['$q', '$http', '$translate', 'apiService', 'lbDialogService', '$state'];

const settingsService = function ($q, $http, $translate, apiService, lbDialogService, $state) {
  let service = {};

  service.settings = null;
  service.getAny = getAny;
  service.get = get;
  service.clear = clear;
  service.isOneWayFare = isOneWayFare;
  service.getRailCards = getRailCards;
  service.currencyCode = currencyCode;
  service.getHotelPaymentNarrativesByIds = getHotelPaymentNarrativesByIds;
  service.isUnusedCreditEnabled = isUnusedCreditEnabled;
  service.isDefaultCostCenter = isDefaultCostCenter;
  service.getErrorContactMsg = getErrorContactMsg;

  let isFetching = false; // flag to indicate whether get() is already running
  let deferred; // promise to return if get() is already running

  function getAny() {
    if (service.settings) {
      let deferredGetAny = $q.defer();
      deferredGetAny.resolve(service.settings);
      return deferredGetAny.promise;
    } else {
      return get();
    }
  }

  function get(force) {
    if (isFetching) return deferred.promise;

    isFetching = true;
    deferred = $q.defer();
    const apiUrl = apiService.getUrl('settings') + (force ? '?force=true' : '');

    $http
      .get(apiUrl)
      .then((response) => {
        let data = response.data;
        service.settings = data;
        if (data.Disabled) {
          window.location.replace(window.location.origin + '/#/lightningdisabled?message=Disabled');
          deferred.reject();
          return;
        }
        data.Locale = 'en-US';
        (data.Countries = [
          {
            Code: 'US',
            Name: 'United States of America',
            Valid: true,
            DisplayOrder: 1,
          },
          {
            Code: 'AF',
            Name: 'Afghanistan',
            Valid: true,
            DisplayOrder: 2,
          },
          {
            Code: 'AX',
            Name: 'Åland Islands',
            Valid: true,
            DisplayOrder: 3,
          },
          {
            Code: 'AL',
            Name: 'Albania',
            Valid: true,
            DisplayOrder: 4,
          },
          {
            Code: 'DZ',
            Name: 'Algeria',
            Valid: true,
            DisplayOrder: 5,
          },
          {
            Code: 'AS',
            Name: 'American Samoa',
            Valid: true,
            DisplayOrder: 6,
          },
          {
            Code: 'AD',
            Name: 'Andorra',
            Valid: true,
            DisplayOrder: 7,
          },
          {
            Code: 'AO',
            Name: 'Angola',
            Valid: true,
            DisplayOrder: 8,
          },
          {
            Code: 'AI',
            Name: 'Anguilla',
            Valid: true,
            DisplayOrder: 9,
          },
          {
            Code: 'AQ',
            Name: 'Antarctica',
            Valid: true,
            DisplayOrder: 10,
          },
          {
            Code: 'AG',
            Name: 'Antigua and Barbuda',
            Valid: true,
            DisplayOrder: 11,
          },
          {
            Code: 'AR',
            Name: 'Argentina',
            Valid: true,
            DisplayOrder: 12,
          },
          {
            Code: 'AM',
            Name: 'Armenia',
            Valid: true,
            DisplayOrder: 13,
          },
          {
            Code: 'AW',
            Name: 'Aruba',
            Valid: true,
            DisplayOrder: 14,
          },
          {
            Code: 'AU',
            Name: 'Australia',
            Valid: true,
            DisplayOrder: 15,
          },
          {
            Code: 'AT',
            Name: 'Austria',
            Valid: true,
            DisplayOrder: 16,
          },
          {
            Code: 'AZ',
            Name: 'Azerbaijan',
            Valid: true,
            DisplayOrder: 17,
          },
          {
            Code: 'BS',
            Name: 'Bahamas',
            Valid: true,
            DisplayOrder: 18,
          },
          {
            Code: 'BH',
            Name: 'Bahrain',
            Valid: true,
            DisplayOrder: 19,
          },
          {
            Code: 'BD',
            Name: 'Bangladesh',
            Valid: true,
            DisplayOrder: 20,
          },
          {
            Code: 'BB',
            Name: 'Barbados',
            Valid: true,
            DisplayOrder: 21,
          },
          {
            Code: 'BY',
            Name: 'Belarus',
            Valid: true,
            DisplayOrder: 22,
          },
          {
            Code: 'BE',
            Name: 'Belgium',
            Valid: true,
            DisplayOrder: 23,
          },
          {
            Code: 'BZ',
            Name: 'Belize',
            Valid: true,
            DisplayOrder: 24,
          },
          {
            Code: 'BJ',
            Name: 'Benin',
            Valid: true,
            DisplayOrder: 25,
          },
          {
            Code: 'BM',
            Name: 'Bermuda',
            Valid: true,
            DisplayOrder: 26,
          },
          {
            Code: 'BT',
            Name: 'Bhutan',
            Valid: true,
            DisplayOrder: 27,
          },
          {
            Code: 'BO',
            Name: 'Bolivia (Plurinational State of)',
            Valid: true,
            DisplayOrder: 28,
          },
          {
            Code: 'BQ',
            Name: 'Bonaire, Sint Eustatius and Saba',
            Valid: true,
            DisplayOrder: 29,
          },
          {
            Code: 'BA',
            Name: 'Bosnia and Herzegovina',
            Valid: true,
            DisplayOrder: 30,
          },
          {
            Code: 'BW',
            Name: 'Botswana',
            Valid: true,
            DisplayOrder: 31,
          },
          {
            Code: 'BV',
            Name: 'Bouvet Island',
            Valid: true,
            DisplayOrder: 32,
          },
          {
            Code: 'BR',
            Name: 'Brazil',
            Valid: true,
            DisplayOrder: 33,
          },
          {
            Code: 'IO',
            Name: 'British Indian Ocean Territory',
            Valid: true,
            DisplayOrder: 34,
          },
          {
            Code: 'BN',
            Name: 'Brunei Darussalam',
            Valid: true,
            DisplayOrder: 35,
          },
          {
            Code: 'BG',
            Name: 'Bulgaria',
            Valid: true,
            DisplayOrder: 36,
          },
          {
            Code: 'BF',
            Name: 'Burkina Faso',
            Valid: true,
            DisplayOrder: 37,
          },
          {
            Code: 'BI',
            Name: 'Burundi',
            Valid: true,
            DisplayOrder: 38,
          },
          {
            Code: 'CV',
            Name: 'Cabo Verde',
            Valid: true,
            DisplayOrder: 39,
          },
          {
            Code: 'KH',
            Name: 'Cambodia',
            Valid: true,
            DisplayOrder: 40,
          },
          {
            Code: 'CM',
            Name: 'Cameroon',
            Valid: true,
            DisplayOrder: 41,
          },
          {
            Code: 'CA',
            Name: 'Canada',
            Valid: true,
            DisplayOrder: 42,
          },
          {
            Code: 'KY',
            Name: 'Cayman Islands',
            Valid: true,
            DisplayOrder: 43,
          },
          {
            Code: 'CF',
            Name: 'Central African Republic',
            Valid: true,
            DisplayOrder: 44,
          },
          {
            Code: 'TD',
            Name: 'Chad',
            Valid: true,
            DisplayOrder: 45,
          },
          {
            Code: 'CL',
            Name: 'Chile',
            Valid: true,
            DisplayOrder: 46,
          },
          {
            Code: 'CN',
            Name: 'China',
            Valid: true,
            DisplayOrder: 47,
          },
          {
            Code: 'CX',
            Name: 'Christmas Island',
            Valid: true,
            DisplayOrder: 48,
          },
          {
            Code: 'CC',
            Name: 'Cocos (Keeling) Islands',
            Valid: true,
            DisplayOrder: 49,
          },
          {
            Code: 'CO',
            Name: 'Colombia',
            Valid: true,
            DisplayOrder: 50,
          },
          {
            Code: 'KM',
            Name: 'Comoros',
            Valid: true,
            DisplayOrder: 51,
          },
          {
            Code: 'CG',
            Name: 'Congo',
            Valid: true,
            DisplayOrder: 52,
          },
          {
            Code: 'CD',
            Name: 'Congo (Democratic Republic of the)',
            Valid: true,
            DisplayOrder: 53,
          },
          {
            Code: 'CK',
            Name: 'Cook Islands',
            Valid: true,
            DisplayOrder: 54,
          },
          {
            Code: 'CR',
            Name: 'Costa Rica',
            Valid: true,
            DisplayOrder: 55,
          },
          {
            Code: 'CI',
            Name: "Côte d'Ivoire",
            Valid: true,
            DisplayOrder: 56,
          },
          {
            Code: 'HR',
            Name: 'Croatia',
            Valid: true,
            DisplayOrder: 57,
          },
          {
            Code: 'CU',
            Name: 'Cuba',
            Valid: true,
            DisplayOrder: 58,
          },
          {
            Code: 'CW',
            Name: 'Curaçao',
            Valid: true,
            DisplayOrder: 59,
          },
          {
            Code: 'CY',
            Name: 'Cyprus',
            Valid: true,
            DisplayOrder: 60,
          },
          {
            Code: 'CZ',
            Name: 'Czechia',
            Valid: true,
            DisplayOrder: 61,
          },
          {
            Code: 'DK',
            Name: 'Denmark',
            Valid: true,
            DisplayOrder: 62,
          },
          {
            Code: 'DJ',
            Name: 'Djibouti',
            Valid: true,
            DisplayOrder: 63,
          },
          {
            Code: 'DM',
            Name: 'Dominica',
            Valid: true,
            DisplayOrder: 64,
          },
          {
            Code: 'DO',
            Name: 'Dominican Republic',
            Valid: true,
            DisplayOrder: 65,
          },
          {
            Code: 'EC',
            Name: 'Ecuador',
            Valid: true,
            DisplayOrder: 66,
          },
          {
            Code: 'EG',
            Name: 'Egypt',
            Valid: true,
            DisplayOrder: 67,
          },
          {
            Code: 'SV',
            Name: 'El Salvador',
            Valid: true,
            DisplayOrder: 68,
          },
          {
            Code: 'GQ',
            Name: 'Equatorial Guinea',
            Valid: true,
            DisplayOrder: 69,
          },
          {
            Code: 'ER',
            Name: 'Eritrea',
            Valid: true,
            DisplayOrder: 70,
          },
          {
            Code: 'EE',
            Name: 'Estonia',
            Valid: true,
            DisplayOrder: 71,
          },
          {
            Code: 'ET',
            Name: 'Ethiopia',
            Valid: true,
            DisplayOrder: 72,
          },
          {
            Code: 'FK',
            Name: 'Falkland Islands (Malvinas)',
            Valid: true,
            DisplayOrder: 73,
          },
          {
            Code: 'FO',
            Name: 'Faroe Islands',
            Valid: true,
            DisplayOrder: 74,
          },
          {
            Code: 'FJ',
            Name: 'Fiji',
            Valid: true,
            DisplayOrder: 75,
          },
          {
            Code: 'FI',
            Name: 'Finland',
            Valid: true,
            DisplayOrder: 76,
          },
          {
            Code: 'FR',
            Name: 'France',
            Valid: true,
            DisplayOrder: 77,
          },
          {
            Code: 'GF',
            Name: 'French Guiana',
            Valid: true,
            DisplayOrder: 78,
          },
          {
            Code: 'PF',
            Name: 'French Polynesia',
            Valid: true,
            DisplayOrder: 79,
          },
          {
            Code: 'TF',
            Name: 'French Southern Territories',
            Valid: true,
            DisplayOrder: 80,
          },
          {
            Code: 'GA',
            Name: 'Gabon',
            Valid: true,
            DisplayOrder: 81,
          },
          {
            Code: 'GM',
            Name: 'Gambia',
            Valid: true,
            DisplayOrder: 82,
          },
          {
            Code: 'GE',
            Name: 'Georgia',
            Valid: true,
            DisplayOrder: 83,
          },
          {
            Code: 'DE',
            Name: 'Germany',
            Valid: true,
            DisplayOrder: 84,
          },
          {
            Code: 'GH',
            Name: 'Ghana',
            Valid: true,
            DisplayOrder: 85,
          },
          {
            Code: 'GI',
            Name: 'Gibraltar',
            Valid: true,
            DisplayOrder: 86,
          },
          {
            Code: 'GR',
            Name: 'Greece',
            Valid: true,
            DisplayOrder: 87,
          },
          {
            Code: 'GL',
            Name: 'Greenland',
            Valid: true,
            DisplayOrder: 88,
          },
          {
            Code: 'GD',
            Name: 'Grenada',
            Valid: true,
            DisplayOrder: 89,
          },
          {
            Code: 'GP',
            Name: 'Guadeloupe',
            Valid: true,
            DisplayOrder: 90,
          },
          {
            Code: 'GU',
            Name: 'Guam',
            Valid: true,
            DisplayOrder: 91,
          },
          {
            Code: 'GT',
            Name: 'Guatemala',
            Valid: true,
            DisplayOrder: 92,
          },
          {
            Code: 'GG',
            Name: 'Guernsey',
            Valid: true,
            DisplayOrder: 93,
          },
          {
            Code: 'GN',
            Name: 'Guinea',
            Valid: true,
            DisplayOrder: 94,
          },
          {
            Code: 'GW',
            Name: 'Guinea-Bissau',
            Valid: true,
            DisplayOrder: 95,
          },
          {
            Code: 'GY',
            Name: 'Guyana',
            Valid: true,
            DisplayOrder: 96,
          },
          {
            Code: 'HT',
            Name: 'Haiti',
            Valid: true,
            DisplayOrder: 97,
          },
          {
            Code: 'HM',
            Name: 'Heard Island and McDonald Islands',
            Valid: true,
            DisplayOrder: 98,
          },
          {
            Code: 'VA',
            Name: 'Holy See',
            Valid: true,
            DisplayOrder: 99,
          },
          {
            Code: 'HN',
            Name: 'Honduras',
            Valid: true,
            DisplayOrder: 100,
          },
          {
            Code: 'HK',
            Name: 'Hong Kong',
            Valid: true,
            DisplayOrder: 101,
          },
          {
            Code: 'HU',
            Name: 'Hungary',
            Valid: true,
            DisplayOrder: 102,
          },
          {
            Code: 'IS',
            Name: 'Iceland',
            Valid: true,
            DisplayOrder: 103,
          },
          {
            Code: 'IN',
            Name: 'India',
            Valid: true,
            DisplayOrder: 104,
          },
          {
            Code: 'ID',
            Name: 'Indonesia',
            Valid: true,
            DisplayOrder: 105,
          },
          {
            Code: 'IR',
            Name: 'Iran (Islamic Republic of)',
            Valid: true,
            DisplayOrder: 106,
          },
          {
            Code: 'IQ',
            Name: 'Iraq',
            Valid: true,
            DisplayOrder: 107,
          },
          {
            Code: 'IE',
            Name: 'Ireland',
            Valid: true,
            DisplayOrder: 108,
          },
          {
            Code: 'IM',
            Name: 'Isle of Man',
            Valid: true,
            DisplayOrder: 109,
          },
          {
            Code: 'IL',
            Name: 'Israel',
            Valid: true,
            DisplayOrder: 110,
          },
          {
            Code: 'IT',
            Name: 'Italy',
            Valid: true,
            DisplayOrder: 111,
          },
          {
            Code: 'JM',
            Name: 'Jamaica',
            Valid: true,
            DisplayOrder: 112,
          },
          {
            Code: 'JP',
            Name: 'Japan',
            Valid: true,
            DisplayOrder: 113,
          },
          {
            Code: 'JE',
            Name: 'Jersey',
            Valid: true,
            DisplayOrder: 114,
          },
          {
            Code: 'JO',
            Name: 'Jordan',
            Valid: true,
            DisplayOrder: 115,
          },
          {
            Code: 'KZ',
            Name: 'Kazakhstan',
            Valid: true,
            DisplayOrder: 116,
          },
          {
            Code: 'KE',
            Name: 'Kenya',
            Valid: true,
            DisplayOrder: 117,
          },
          {
            Code: 'KI',
            Name: 'Kiribati',
            Valid: true,
            DisplayOrder: 118,
          },
          {
            Code: 'KP',
            Name: "Korea (Democratic People's Republic of)",
            Valid: true,
            DisplayOrder: 119,
          },
          {
            Code: 'KR',
            Name: 'Korea (Republic of)',
            Valid: true,
            DisplayOrder: 120,
          },
          {
            Code: 'KW',
            Name: 'Kuwait',
            Valid: true,
            DisplayOrder: 121,
          },
          {
            Code: 'KG',
            Name: 'Kyrgyzstan',
            Valid: true,
            DisplayOrder: 122,
          },
          {
            Code: 'LA',
            Name: "Lao People's Democratic Republic",
            Valid: true,
            DisplayOrder: 123,
          },
          {
            Code: 'LV',
            Name: 'Latvia',
            Valid: true,
            DisplayOrder: 124,
          },
          {
            Code: 'LB',
            Name: 'Lebanon',
            Valid: true,
            DisplayOrder: 125,
          },
          {
            Code: 'LS',
            Name: 'Lesotho',
            Valid: true,
            DisplayOrder: 126,
          },
          {
            Code: 'LR',
            Name: 'Liberia',
            Valid: true,
            DisplayOrder: 127,
          },
          {
            Code: 'LY',
            Name: 'Libya',
            Valid: true,
            DisplayOrder: 128,
          },
          {
            Code: 'LI',
            Name: 'Liechtenstein',
            Valid: true,
            DisplayOrder: 129,
          },
          {
            Code: 'LT',
            Name: 'Lithuania',
            Valid: true,
            DisplayOrder: 130,
          },
          {
            Code: 'LU',
            Name: 'Luxembourg',
            Valid: true,
            DisplayOrder: 131,
          },
          {
            Code: 'MO',
            Name: 'Macao',
            Valid: true,
            DisplayOrder: 132,
          },
          {
            Code: 'MK',
            Name: 'Macedonia (the former Yugoslav Republic of)',
            Valid: true,
            DisplayOrder: 133,
          },
          {
            Code: 'MG',
            Name: 'Madagascar',
            Valid: true,
            DisplayOrder: 134,
          },
          {
            Code: 'MW',
            Name: 'Malawi',
            Valid: true,
            DisplayOrder: 135,
          },
          {
            Code: 'MY',
            Name: 'Malaysia',
            Valid: true,
            DisplayOrder: 136,
          },
          {
            Code: 'MV',
            Name: 'Maldives',
            Valid: true,
            DisplayOrder: 137,
          },
          {
            Code: 'ML',
            Name: 'Mali',
            Valid: true,
            DisplayOrder: 138,
          },
          {
            Code: 'MT',
            Name: 'Malta',
            Valid: true,
            DisplayOrder: 139,
          },
          {
            Code: 'MH',
            Name: 'Marshall Islands',
            Valid: true,
            DisplayOrder: 140,
          },
          {
            Code: 'MQ',
            Name: 'Martinique',
            Valid: true,
            DisplayOrder: 141,
          },
          {
            Code: 'MR',
            Name: 'Mauritania',
            Valid: true,
            DisplayOrder: 142,
          },
          {
            Code: 'MU',
            Name: 'Mauritius',
            Valid: true,
            DisplayOrder: 143,
          },
          {
            Code: 'YT',
            Name: 'Mayotte',
            Valid: true,
            DisplayOrder: 144,
          },
          {
            Code: 'MX',
            Name: 'Mexico',
            Valid: true,
            DisplayOrder: 145,
          },
          {
            Code: 'FM',
            Name: 'Micronesia (Federated States of)',
            Valid: true,
            DisplayOrder: 146,
          },
          {
            Code: 'MD',
            Name: 'Moldova (Republic of)',
            Valid: true,
            DisplayOrder: 147,
          },
          {
            Code: 'MC',
            Name: 'Monaco',
            Valid: true,
            DisplayOrder: 148,
          },
          {
            Code: 'MN',
            Name: 'Mongolia',
            Valid: true,
            DisplayOrder: 149,
          },
          {
            Code: 'ME',
            Name: 'Montenegro',
            Valid: true,
            DisplayOrder: 150,
          },
          {
            Code: 'MS',
            Name: 'Montserrat',
            Valid: true,
            DisplayOrder: 151,
          },
          {
            Code: 'MA',
            Name: 'Morocco',
            Valid: true,
            DisplayOrder: 152,
          },
          {
            Code: 'MZ',
            Name: 'Mozambique',
            Valid: true,
            DisplayOrder: 153,
          },
          {
            Code: 'MM',
            Name: 'Myanmar',
            Valid: true,
            DisplayOrder: 154,
          },
          {
            Code: 'NA',
            Name: 'Namibia',
            Valid: true,
            DisplayOrder: 155,
          },
          {
            Code: 'NR',
            Name: 'Nauru',
            Valid: true,
            DisplayOrder: 156,
          },
          {
            Code: 'NP',
            Name: 'Nepal',
            Valid: true,
            DisplayOrder: 157,
          },
          {
            Code: 'NL',
            Name: 'Netherlands',
            Valid: true,
            DisplayOrder: 158,
          },
          {
            Code: 'NC',
            Name: 'New Caledonia',
            Valid: true,
            DisplayOrder: 159,
          },
          {
            Code: 'NZ',
            Name: 'New Zealand',
            Valid: true,
            DisplayOrder: 160,
          },
          {
            Code: 'NI',
            Name: 'Nicaragua',
            Valid: true,
            DisplayOrder: 161,
          },
          {
            Code: 'NE',
            Name: 'Niger',
            Valid: true,
            DisplayOrder: 162,
          },
          {
            Code: 'NG',
            Name: 'Nigeria',
            Valid: true,
            DisplayOrder: 163,
          },
          {
            Code: 'NU',
            Name: 'Niue',
            Valid: true,
            DisplayOrder: 164,
          },
          {
            Code: 'NF',
            Name: 'Norfolk Island',
            Valid: true,
            DisplayOrder: 165,
          },
          {
            Code: 'MP',
            Name: 'Northern Mariana Islands',
            Valid: true,
            DisplayOrder: 166,
          },
          {
            Code: 'NO',
            Name: 'Norway',
            Valid: true,
            DisplayOrder: 167,
          },
          {
            Code: 'OM',
            Name: 'Oman',
            Valid: true,
            DisplayOrder: 168,
          },
          {
            Code: 'PK',
            Name: 'Pakistan',
            Valid: true,
            DisplayOrder: 169,
          },
          {
            Code: 'PW',
            Name: 'Palau',
            Valid: true,
            DisplayOrder: 170,
          },
          {
            Code: 'PS',
            Name: 'Palestine, State of',
            Valid: true,
            DisplayOrder: 171,
          },
          {
            Code: 'PA',
            Name: 'Panama',
            Valid: true,
            DisplayOrder: 172,
          },
          {
            Code: 'PG',
            Name: 'Papua New Guinea',
            Valid: true,
            DisplayOrder: 173,
          },
          {
            Code: 'PY',
            Name: 'Paraguay',
            Valid: true,
            DisplayOrder: 174,
          },
          {
            Code: 'PE',
            Name: 'Peru',
            Valid: true,
            DisplayOrder: 175,
          },
          {
            Code: 'PH',
            Name: 'Philippines',
            Valid: true,
            DisplayOrder: 176,
          },
          {
            Code: 'PN',
            Name: 'Pitcairn',
            Valid: true,
            DisplayOrder: 177,
          },
          {
            Code: 'PL',
            Name: 'Poland',
            Valid: true,
            DisplayOrder: 178,
          },
          {
            Code: 'PT',
            Name: 'Portugal',
            Valid: true,
            DisplayOrder: 179,
          },
          {
            Code: 'PR',
            Name: 'Puerto Rico',
            Valid: true,
            DisplayOrder: 180,
          },
          {
            Code: 'QA',
            Name: 'Qatar',
            Valid: true,
            DisplayOrder: 181,
          },
          {
            Code: 'RE',
            Name: 'Réunion',
            Valid: true,
            DisplayOrder: 182,
          },
          {
            Code: 'RO',
            Name: 'Romania',
            Valid: true,
            DisplayOrder: 183,
          },
          {
            Code: 'RU',
            Name: 'Russian Federation',
            Valid: true,
            DisplayOrder: 184,
          },
          {
            Code: 'RW',
            Name: 'Rwanda',
            Valid: true,
            DisplayOrder: 185,
          },
          {
            Code: 'BL',
            Name: 'Saint Barthélemy',
            Valid: true,
            DisplayOrder: 186,
          },
          {
            Code: 'SH',
            Name: 'Saint Helena, Ascension and Tristan da Cunha',
            Valid: true,
            DisplayOrder: 187,
          },
          {
            Code: 'KN',
            Name: 'Saint Kitts and Nevis',
            Valid: true,
            DisplayOrder: 188,
          },
          {
            Code: 'LC',
            Name: 'Saint Lucia',
            Valid: true,
            DisplayOrder: 189,
          },
          {
            Code: 'MF',
            Name: 'Saint Martin (French part)',
            Valid: true,
            DisplayOrder: 190,
          },
          {
            Code: 'PM',
            Name: 'Saint Pierre and Miquelon',
            Valid: true,
            DisplayOrder: 191,
          },
          {
            Code: 'VC',
            Name: 'Saint Vincent and the Grenadines',
            Valid: true,
            DisplayOrder: 192,
          },
          {
            Code: 'WS',
            Name: 'Samoa',
            Valid: true,
            DisplayOrder: 193,
          },
          {
            Code: 'SM',
            Name: 'San Marino',
            Valid: true,
            DisplayOrder: 194,
          },
          {
            Code: 'ST',
            Name: 'Sao Tome and Principe',
            Valid: true,
            DisplayOrder: 195,
          },
          {
            Code: 'SA',
            Name: 'Saudi Arabia',
            Valid: true,
            DisplayOrder: 196,
          },
          {
            Code: 'SN',
            Name: 'Senegal',
            Valid: true,
            DisplayOrder: 197,
          },
          {
            Code: 'RS',
            Name: 'Serbia',
            Valid: true,
            DisplayOrder: 198,
          },
          {
            Code: 'SC',
            Name: 'Seychelles',
            Valid: true,
            DisplayOrder: 199,
          },
          {
            Code: 'SL',
            Name: 'Sierra Leone',
            Valid: true,
            DisplayOrder: 200,
          },
          {
            Code: 'SG',
            Name: 'Singapore',
            Valid: true,
            DisplayOrder: 201,
          },
          {
            Code: 'SX',
            Name: 'Sint Maarten (Dutch part)',
            Valid: true,
            DisplayOrder: 202,
          },
          {
            Code: 'SK',
            Name: 'Slovakia',
            Valid: true,
            DisplayOrder: 203,
          },
          {
            Code: 'SI',
            Name: 'Slovenia',
            Valid: true,
            DisplayOrder: 204,
          },
          {
            Code: 'SB',
            Name: 'Solomon Islands',
            Valid: true,
            DisplayOrder: 205,
          },
          {
            Code: 'SO',
            Name: 'Somalia',
            Valid: true,
            DisplayOrder: 206,
          },
          {
            Code: 'ZA',
            Name: 'South Africa',
            Valid: true,
            DisplayOrder: 207,
          },
          {
            Code: 'GS',
            Name: 'South Georgia and the South Sandwich Islands',
            Valid: true,
            DisplayOrder: 208,
          },
          {
            Code: 'SS',
            Name: 'South Sudan',
            Valid: true,
            DisplayOrder: 209,
          },
          {
            Code: 'ES',
            Name: 'Spain',
            Valid: true,
            DisplayOrder: 210,
          },
          {
            Code: 'LK',
            Name: 'Sri Lanka',
            Valid: true,
            DisplayOrder: 211,
          },
          {
            Code: 'SD',
            Name: 'Sudan',
            Valid: true,
            DisplayOrder: 212,
          },
          {
            Code: 'SR',
            Name: 'Suriname',
            Valid: true,
            DisplayOrder: 213,
          },
          {
            Code: 'SJ',
            Name: 'Svalbard and Jan Mayen',
            Valid: true,
            DisplayOrder: 214,
          },
          {
            Code: 'SZ',
            Name: 'Swaziland',
            Valid: true,
            DisplayOrder: 215,
          },
          {
            Code: 'SE',
            Name: 'Sweden',
            Valid: true,
            DisplayOrder: 216,
          },
          {
            Code: 'CH',
            Name: 'Switzerland',
            Valid: true,
            DisplayOrder: 217,
          },
          {
            Code: 'SY',
            Name: 'Syrian Arab Republic',
            Valid: true,
            DisplayOrder: 218,
          },
          {
            Code: 'TW',
            Name: 'Taiwan, Province of China',
            Valid: true,
            DisplayOrder: 219,
          },
          {
            Code: 'TJ',
            Name: 'Tajikistan',
            Valid: true,
            DisplayOrder: 220,
          },
          {
            Code: 'TZ',
            Name: 'Tanzania, United Republic of',
            Valid: true,
            DisplayOrder: 221,
          },
          {
            Code: 'TH',
            Name: 'Thailand',
            Valid: true,
            DisplayOrder: 222,
          },
          {
            Code: 'TL',
            Name: 'Timor-Leste',
            Valid: true,
            DisplayOrder: 223,
          },
          {
            Code: 'TG',
            Name: 'Togo',
            Valid: true,
            DisplayOrder: 224,
          },
          {
            Code: 'TK',
            Name: 'Tokelau',
            Valid: true,
            DisplayOrder: 225,
          },
          {
            Code: 'TO',
            Name: 'Tonga',
            Valid: true,
            DisplayOrder: 226,
          },
          {
            Code: 'TT',
            Name: 'Trinidad and Tobago',
            Valid: true,
            DisplayOrder: 227,
          },
          {
            Code: 'TN',
            Name: 'Tunisia',
            Valid: true,
            DisplayOrder: 228,
          },
          {
            Code: 'TR',
            Name: 'Turkey',
            Valid: true,
            DisplayOrder: 229,
          },
          {
            Code: 'TM',
            Name: 'Turkmenistan',
            Valid: true,
            DisplayOrder: 230,
          },
          {
            Code: 'TC',
            Name: 'Turks and Caicos Islands',
            Valid: true,
            DisplayOrder: 231,
          },
          {
            Code: 'TV',
            Name: 'Tuvalu',
            Valid: true,
            DisplayOrder: 232,
          },
          {
            Code: 'UG',
            Name: 'Uganda',
            Valid: true,
            DisplayOrder: 233,
          },
          {
            Code: 'UA',
            Name: 'Ukraine',
            Valid: true,
            DisplayOrder: 234,
          },
          {
            Code: 'AE',
            Name: 'United Arab Emirates',
            Valid: true,
            DisplayOrder: 235,
          },
          {
            Code: 'GB',
            Name: 'United Kingdom of Great Britain and Northern Ireland',
            Valid: true,
            DisplayOrder: 236,
          },
          {
            Code: 'UM',
            Name: 'United States Minor Outlying Islands',
            Valid: true,
            DisplayOrder: 237,
          },
          {
            Code: 'UY',
            Name: 'Uruguay',
            Valid: true,
            DisplayOrder: 238,
          },
          {
            Code: 'UZ',
            Name: 'Uzbekistan',
            Valid: true,
            DisplayOrder: 239,
          },
          {
            Code: 'VU',
            Name: 'Vanuatu',
            Valid: true,
            DisplayOrder: 240,
          },
          {
            Code: 'VE',
            Name: 'Venezuela (Bolivarian Republic of)',
            Valid: true,
            DisplayOrder: 241,
          },
          {
            Code: 'VN',
            Name: 'Viet Nam',
            Valid: true,
            DisplayOrder: 242,
          },
          {
            Code: 'VG',
            Name: 'Virgin Islands (British)',
            Valid: true,
            DisplayOrder: 243,
          },
          {
            Code: 'VI',
            Name: 'Virgin Islands (U.S.)',
            Valid: true,
            DisplayOrder: 244,
          },
          {
            Code: 'WF',
            Name: 'Wallis and Futuna',
            Valid: true,
            DisplayOrder: 245,
          },
          {
            Code: 'EH',
            Name: 'Western Sahara',
            Valid: true,
            DisplayOrder: 246,
          },
          {
            Code: 'YE',
            Name: 'Yemen',
            Valid: true,
            DisplayOrder: 247,
          },
          {
            Code: 'ZM',
            Name: 'Zambia',
            Valid: true,
            DisplayOrder: 248,
          },
          {
            Code: 'ZW',
            Name: 'Zimbabwe',
            Valid: true,
            DisplayOrder: 249,
          },
        ]),
          (data.GuestTravellersSuffixes = [
            {
              Code: 'CFRE',
              Name: 'CFRE',
              Valid: true,
              DisplayOrder: 1,
            },
            {
              Code: 'CLU',
              Name: 'CLU',
              Valid: true,
              DisplayOrder: 2,
            },
            {
              Code: 'CPA',
              Name: 'CPA',
              Valid: true,
              DisplayOrder: 3,
            },
            {
              Code: 'DC',
              Name: 'D.C.',
              Valid: true,
              DisplayOrder: 4,
            },
            {
              Code: 'DD',
              Name: 'D.D.',
              Valid: true,
              DisplayOrder: 5,
            },
            {
              Code: 'DDS',
              Name: 'D.D.S.',
              Valid: true,
              DisplayOrder: 6,
            },
            {
              Code: 'DMD',
              Name: 'D.M.D.',
              Valid: true,
              DisplayOrder: 7,
            },
            {
              Code: 'DO',
              Name: 'D.O.',
              Valid: true,
              DisplayOrder: 8,
            },
            {
              Code: 'DVM',
              Name: 'D.V.M.',
              Valid: true,
              DisplayOrder: 9,
            },
            {
              Code: 'EDD',
              Name: 'Ed.D.',
              Valid: true,
              DisplayOrder: 10,
            },
            {
              Code: 'ESQ',
              Name: 'Esq.',
              Valid: true,
              DisplayOrder: 11,
            },
            {
              Code: 'II',
              Name: 'II',
              Valid: true,
              DisplayOrder: 12,
            },
            {
              Code: 'III',
              Name: 'III',
              Valid: true,
              DisplayOrder: 13,
            },
            {
              Code: 'IV',
              Name: 'IV',
              Valid: true,
              DisplayOrder: 14,
            },
            {
              Code: 'JD',
              Name: 'J.D.',
              Valid: true,
              DisplayOrder: 15,
            },
            {
              Code: 'JR',
              Name: 'Jr.',
              Valid: true,
              DisplayOrder: 16,
            },
            {
              Code: 'LLD',
              Name: 'LL.D.',
              Valid: true,
              DisplayOrder: 17,
            },
            {
              Code: 'MD',
              Name: 'M.D.',
              Valid: true,
              DisplayOrder: 18,
            },
            {
              Code: 'OD',
              Name: 'O.D.',
              Valid: true,
              DisplayOrder: 19,
            },
            {
              Code: 'PC',
              Name: 'P.C.',
              Valid: true,
              DisplayOrder: 20,
            },
            {
              Code: 'PE',
              Name: 'P.E.',
              Valid: true,
              DisplayOrder: 21,
            },
            {
              Code: 'PHD',
              Name: 'Ph.D.',
              Valid: true,
              DisplayOrder: 22,
            },
            {
              Code: 'RET',
              Name: 'Ret.',
              Valid: true,
              DisplayOrder: 23,
            },
            {
              Code: 'RN',
              Name: 'R.N.',
              Valid: true,
              DisplayOrder: 24,
            },
            {
              Code: 'RNC',
              Name: 'R.N.C.',
              Valid: true,
              DisplayOrder: 25,
            },
            {
              Code: 'SR',
              Name: 'Sr.',
              Valid: true,
              DisplayOrder: 26,
            },
          ]);

        if (data.Locale) {
          setLocation(data.Locale);
        }
        isFetching = false; // reset flag
        initializePendo(service.settings.UserDetails);
        deferred.resolve(service.settings); // resolve the promise with the data
      })
      .catch(function (error) {
        isFetching = false;
        lbDialogService
          .show({
            title: 'Internal Error',
            message: 'There was an error loading the settings. Please refresh the page.',
            warningLevel: 'warning',
            showCancelButton: false,
            customRejectButtonText: 'Logout',
            submitButtonText: 'Refresh Page',
          })
          .then(
            function () {
              location.reload();
            },
            function () {
              window.location.replace(window.location.origin + '/#/login?logout=true');
            }
          );
        deferred.reject(error);
      });

    return deferred.promise;
  }

  function clear() {
    service.settings = null;
  }

  function setLocation(locationCode) {
    window.localStorage.setItem('i18nCode', locationCode);
    $translate.use(locationCode);
  }

  function isOneWayFare(origin, destination) {
    return _.some(service.settings.FlightConfiguration.OneWayFareRules, (rule) => {
      return rule.Origin === origin.CountryCode && rule.Destination === destination.CountryCode;
    });
  }

  function getRailCards() {
    if (!service.settings.RailConfiguration || !service.settings.RailConfiguration.RailCard) {
      return undefined;
    }

    return service.settings.RailConfiguration.RailCard;
  }

  function currencyCode() {
    return service.settings.Currency.Code;
  }

  function getHotelPaymentNarrativesByIds(codes) {
    return _.filter(service.settings.HotelConfiguration.PaymentNarratives, (narrative) => {
      return _.includes(codes, narrative.PaymentCode);
    });
  }

  function isUnusedCreditEnabled() {
    return service.settings.FlightConfiguration.EnableUnusedCredit;
  }

  function isDefaultCostCenter(value) {
    return !(value && value != 'No Cost Center' && value != 'No Cost Centre' && value != 'N/A');
  }

  function getErrorContactMsg() {
    let msg = 'If you are receiving this error after retrying, you may reach out to our Online Support team';
    if (service.settings.DebtorSupport && service.settings.DebtorSupport && service.settings.DebtorSupport.Email) {
      msg +=
        ' at  <a href="mailto:' +
        service.settings.DebtorSupport.Email +
        '">' +
        service.settings.DebtorSupport.Email +
        '</a> for assistance';
    } else if (service.settings.DebtorSupport && service.settings.DebtorSupport && service.settings.DebtorSupport.Phone) {
      msg +=
        ' at  <a href="tel:' + service.settings.DebtorSupport.Phone + '">' + service.settings.DebtorSupport.Phone + '</a> for assistance';
    }
    if (service.settings.SupportInformation && service.settings.SupportInformation.Phone) {
      msg +=
        ', or to book immediately with an agent, please call <a href="tel:' +
        service.settings.SupportInformation.Phone +
        '">' +
        service.settings.SupportInformation.Phone +
        '</a>';
    }
    msg += '.';
    return msg;
  }

  function initializePendo(userDetails) {
    if (!userDetails || !window.pendo) return;
    const { UserName, UserEmail, UserDebtor, UserDebtorName } = userDetails;
    const firstName = getUserFirstName(UserName);
    const lastName = getUserLastName(UserName);
    const pendoRequest = {
      visitor: {
        firstname: firstName,
        lastname: lastName,
        id: UserEmail,
        language: 'English',
        email: UserEmail,
      },
      account: {
        id: UserDebtor,
        name: UserDebtorName,
        internal: window.IS_TEST_MODE,
      },
    };
    window.pendo.initialize(pendoRequest);
  }

  return service;
};

function getUserFirstName(fullName) {
  if (!fullName) return '';
  const fullNameSplit = fullName.split(' ');
  return fullNameSplit[0];
}

function getUserLastName(fullName) {
  if (!fullName) return '';
  const fullNameSplit = fullName.split(' ');
  return fullNameSplit[fullNameSplit.length - 1];
}

settingsService.$inject = $inject;

export default settingsService;



// WEBPACK FOOTER //
// ./src/services/settingsService.js